import { FormLabel } from '../../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Control, Controller } from 'react-hook-form';
import { Input } from 'antd';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';

const FullStamp = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.ZPgEroRALL)}:</FormLabel>
      <Controller
        name={`productList.${index}.fullStamp`}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            className="w-full"
            placeholder={i18n.t(LOCALS.please_enter) || ''}
          />
        )}
      />
    </div>
  );
};

export default FullStamp;
